var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _vm.formInfo.types !== 3
        ? _c(
            "div",
            { staticClass: "btn-box" },
            [
              _vm.buildData.contract_renew_switch != 0
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBuild(
                            0,
                            _vm.buildData.contract_renew_switch,
                            "contract_renew_switch"
                          )
                        },
                      },
                    },
                    [_vm._v("\n      添加续费\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.buildData.contract_disburse_switch != 0
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBuild(
                            0,
                            _vm.buildData.contract_disburse_switch,
                            "contract_disburse_switch"
                          )
                        },
                      },
                    },
                    [_vm._v("\n      添加支出\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.buildData.contract_refund_switch != 0
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBuild(
                            0,
                            _vm.buildData.contract_refund_switch,
                            "contract_refund_switch"
                          )
                        },
                      },
                    },
                    [_vm._v("\n      添加回款\n    ")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "amount mt10" }, [
        _vm.paymentPrice.payment_price != "0.00"
          ? _c("div", { staticClass: "mr36" }, [
              _c("span", { staticClass: "amount-label" }, [
                _vm._v("累计收款金额(元)："),
              ]),
              _c("span", { staticClass: "amount-val incomeColor" }, [
                _vm._v(_vm._s(_vm.paymentPrice.payment_price)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.paymentPrice.expense_price != "0.00"
          ? _c("div", { staticClass: "mr36" }, [
              _c("span", { staticClass: "amount-label" }, [
                _vm._v("累计支出金额(元)："),
              ]),
              _c("span", { staticClass: "expendColor" }, [
                _vm._v(_vm._s(_vm.paymentPrice.expense_price)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.paymentPrice.audit_income_price != "0.00" ||
        _vm.paymentPrice.audit_expense_price != "0.00"
          ? _c("div", [
              _c("span", { staticClass: "amount-label" }, [
                _vm._v("审核中金额(元)："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "amount-val" }, [
                _c("span", { staticClass: "incomeColor" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.paymentPrice.audit_income_price) +
                      "(收入) "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "expendColor ml10" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.paymentPrice.audit_expense_price) +
                      "(支出)"
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          class: _vm.debtData.length > 0 ? "" : "mb15",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.debtData },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "date", label: "付款时间", "min-width": "150" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "bill_types",
              label: "记录类型",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.types == 2 ? "warning" : "success",
                        },
                      },
                      [_vm._v(_vm._s(scope.row.types == 2 ? "支出" : "收入"))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "num", label: "付款金额(元)", "min-width": "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "pay_type", label: "支付方式", "min-width": "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.pay_type !== "" ? scope.row.pay_type : "--"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bill_no", label: "付款单号", "min-width": "110" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "付款审核状态",
              "min-width": "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "mini" } },
                          [_vm._v(" " + _vm._s(_vm.$t("customer.audit")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v(" " + _vm._s(_vm.$t("customer.passed")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === -1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v("已撤回")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 2
                      ? _c(
                          "el-popover",
                          { attrs: { trigger: "hover", placement: "top" } },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("customer.reason")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(scope.row.fail_msg))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("customer.fail"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              "min-width": "100",
              label: _vm.$t("public.operation"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCheck(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.userInfo.userId == scope.row.card.user_id
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.withdraw(scope.row)
                                  },
                                },
                              },
                              [_vm._v("撤回")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block mt10 text-right" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.where.page,
              layout: "total, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: { "current-change": _vm.renewChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: { isMark: _vm.isOk },
      }),
      _vm._v(" "),
      _c("applyForPayment", {
        ref: "applyForPayment",
        attrs: { "form-data": _vm.fromData },
      }),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("detail-examine", {
        ref: "detailExamine",
        on: { getList: _vm.getTableData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }